import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentActionsMenuGroupId } from './useTrackAgentActionsMenuGroupOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { WorkspaceAgentActionsMenuGroupId } from './useTrackAgentActionsMenuGroupOpened.meta';

export type UseTrackAgentActionsMenuGroupOpenedParams = {
  group_id: WorkspaceAgentActionsMenuGroupId;
};

export const useTrackAgentActionsMenuGroupOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentActionsMenuGroupOpened = useCallback(
    (params: UseTrackAgentActionsMenuGroupOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentActionsMenuGroupOpened };
};
